import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import axiosInstance from "../api";
import { GET_SETTINGS } from "../constants";


export const getSettings = () => async (dispatch) => {
    try {
        const response = await axiosInstance.get(
            `setting`
        );
        if (response?.data?.status) {
            dispatch({ type: GET_SETTINGS, settingList: response?.data?.response });
            return;
        }
    } catch (err) {
        //urtoast(err.message, 2);
    }
};
